export default __webpack_public_path__ + "locales/ja-JP/Errors.json?hash=f8099c6b30a32948515a8fc7e793089e";